import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { authState } from "rxfire/auth";

// Set up Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAQES-xKeXAUbh9bvR2Wg0SiKEf2TMByHg",
  authDomain: "iswallbank-8c4bc.firebaseapp.com",
  projectId: "iswallbank-8c4bc",
  storageBucket: "iswallbank-8c4bc.firebasestorage.app",
  messagingSenderId: "417332905815",
  appId: "1:417332905815:web:27e8b95ad26ebecce42012"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth();
const db = getFirestore(app);

const storage = getStorage(app);

// Listen only for logged in state
const loggedIn$ = authState(auth);

export {
  app,
  loggedIn$,
  auth,
  db,
  storage,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
};
